import script from "./informationdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./informationdetail.vue?vue&type=script&setup=true&lang=js"

import "./informationdetail.vue?vue&type=style&index=0&id=1f671643&lang=scss"
import "./informationdetail.vue?vue&type=style&index=1&id=1f671643&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f671643"]])

export default __exports__